import { render, staticRenderFns } from "./NoticeSetting.vue?vue&type=template&id=cb7c1de4"
import script from "./NoticeSetting.vue?vue&type=script&lang=ts"
export * from "./NoticeSetting.vue?vue&type=script&lang=ts"
import style0 from "./NoticeSetting.vue?vue&type=style&index=0&id=cb7c1de4&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports